// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QuWC","icon":"styles_icon__1PN8I"};